document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".hpm[data-section-id]").forEach((section) => {
    const id = section.dataset.sectionId;

    const elA = section.querySelector(`#hpm-a-${id}`);
    const elB = section.querySelector(`#hpm-b-${id}`);
    if (!elA || !elB || typeof Splide === "undefined") return;

    let splideA = null;
    let splideB = null;
    let resizeTimer = null;
    let debugPaused = false;

    const countA = Number(section.dataset.colACount || 0);
    const countB = Number(section.dataset.colBCount || 0);

    const MIN_FOR_LOOP = 3;
    const enableLoopA = countA >= MIN_FOR_LOOP;
    const enableLoopB = countB >= MIN_FOR_LOOP;

    const speedSetting = Number(section.dataset.speed || 1);
    const directionMode = section.dataset.direction || "same";

    const baseSpeed = speedSetting * 0.3;
    const dirA = 1;
    const dirB = directionMode === "opposite" ? -1 : 1;

    const AutoScrollExt =
      (window.splide &&
        window.splide.Extensions &&
        window.splide.Extensions.AutoScroll) ||
      window.AutoScroll;

    const readNumFrom = (styles, name, fallback) => {
      const raw = (styles.getPropertyValue(name) || "").trim();
      const num = parseFloat(raw);
      return Number.isFinite(num) ? num : fallback;
    };

    const pauseAll = () => {
      splideA?.Components?.AutoScroll?.pause?.();
      splideB?.Components?.AutoScroll?.pause?.();
    };

    const playAll = () => {
      splideA?.Components?.AutoScroll?.play?.();
      splideB?.Components?.AutoScroll?.play?.();
    };

    const addDebugToggle = () => {
      let btn = section.querySelector(".hpm__debug-toggle");
      if (btn) return;

      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "hpm__debug-toggle";
      btn.textContent = "⏸";

      Object.assign(btn.style, {
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 9999,
        width: "42px",
        height: "42px",
        borderRadius: "999px",
        border: "1px solid rgba(0,0,0,.2)",
        background: "rgba(255,255,255,.9)",
        cursor: "pointer",
        display: "grid",
        placeItems: "center",
        fontSize: "18px",
        lineHeight: "1",
        boxShadow: "0 6px 18px rgba(0,0,0,.15)",
      });

      const pos = getComputedStyle(section).position;
      if (pos === "static") section.style.position = "relative";

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        debugPaused = !debugPaused;

        if (debugPaused) {
          pauseAll();
          btn.textContent = "▶";
          btn.title = "Resume";
        } else {
          playAll();
          btn.textContent = "⏸";
          btn.title = "Pause";
        }
      });

      section.appendChild(btn);
    };

    const make = (
      root,
      enableLoop,
      signedSpeed,
      trackHeightPx,
      fixedHeightPx,
      gapPx,
      allowDrag
    ) =>
      new Splide(root, {
        type: enableLoop ? "loop" : "slide",
        arrows: false,
        pagination: false,
        direction: "ttb",
        height: `${trackHeightPx}px`,
        fixedHeight: `${fixedHeightPx}px`,
        gap: `${gapPx}px`,
        perPage: 1,
        perMove: 1,
        drag: allowDrag,
        updateOnMove: true,
        autoScroll: {
          speed: signedSpeed,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      });

    const mountSplides = () => {
      splideA?.destroy?.(true);
      splideB?.destroy?.(true);

      const styles = window.getComputedStyle(section);
      const gapPx = Math.round(readNumFrom(styles, "--hpm-gap", 18));
const ratioW = readNumFrom(styles, "--hpm-card-ratio-w", 2);
const ratioH = readNumFrom(styles, "--hpm-card-ratio-h", 3);
      const isStacked = window.innerWidth <= 1000;
      const cols = section.querySelector(".hpm__cols");

      let cardWPx;

      if (isStacked && cols) {
        const colsWidth = cols.getBoundingClientRect().width;
        cardWPx = (colsWidth - gapPx) / 2;
      } else {
        const splideWidthA = elA.getBoundingClientRect().width;
        const splideWidthB = elB.getBoundingClientRect().width;
        cardWPx = Math.min(splideWidthA, splideWidthB);
      }

      cardWPx = Math.max(120, Math.round(cardWPx));

const fixedHeightPx = Math.round(cardWPx * (ratioH / ratioW));
      const visibleCards = isStacked ? 1.34 : 1.72;
      const visibleCount = Math.ceil(visibleCards);

      const naturalTrackHeightPx = Math.round(
        fixedHeightPx * visibleCards + gapPx * Math.max(0, visibleCount - 1)
      );

      const minTrackHeightPx = Math.round(
        fixedHeightPx * (isStacked ? 1.08 : 1.42)
      );

      const cssTrackHeightPx = Math.round(
        readNumFrom(styles, "--hpm-track-h", naturalTrackHeightPx)
      );

      const desktopMaxTrackHeightPx = 680;
      const mobileMaxTrackHeightPx = 520;
      const maxTrackHeightPx = isStacked
        ? mobileMaxTrackHeightPx
        : desktopMaxTrackHeightPx;

      const trackHeightPx = Math.max(
        minTrackHeightPx,
        Math.min(Math.max(naturalTrackHeightPx, cssTrackHeightPx), maxTrackHeightPx)
      );

      section.style.setProperty("--hpm-track-h", `${trackHeightPx}px`);
      section.style.setProperty(
        "--hpm-col-offset",
        `${isStacked ? 0 : Number(section.dataset.offset || 20)}px`
      );

      splideA = make(
        elA,
        enableLoopA,
        baseSpeed * dirA,
        trackHeightPx,
        fixedHeightPx,
        gapPx,
        false
      );

      splideB = make(
        elB,
        enableLoopB,
        baseSpeed * dirB,
        trackHeightPx,
        fixedHeightPx,
        gapPx,
        false
      );

      if (enableLoopA && AutoScrollExt) {
        splideA.mount({ AutoScroll: AutoScrollExt });
      } else {
        splideA.mount();
      }

      if (enableLoopB && AutoScrollExt) {
        splideB.mount({ AutoScroll: AutoScrollExt });
      } else {
        splideB.mount();
      }

      if (!debugPaused) {
        splideA?.Components?.AutoScroll?.play?.();
        splideB?.Components?.AutoScroll?.play?.();
      } else {
        splideA?.Components?.AutoScroll?.pause?.();
        splideB?.Components?.AutoScroll?.pause?.();
      }
    };

    addDebugToggle();
    mountSplides();

    const hoverTarget = section.querySelector(".hpm__right");
    if (hoverTarget && !hoverTarget.dataset.hpmBound) {
      hoverTarget.dataset.hpmBound = "true";

      hoverTarget.addEventListener("pointerenter", () => {
        if (!debugPaused) pauseAll();
      });

      hoverTarget.addEventListener("pointerleave", () => {
        if (!debugPaused) playAll();
      });

      hoverTarget.addEventListener("focusin", () => {
        if (!debugPaused) pauseAll();
      });

      hoverTarget.addEventListener("focusout", () => {
        if (!debugPaused) playAll();
      });
    }

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        mountSplides();
      }, 180);
    });
  });
});